import { mapTypenameToResourceType } from "shared/api/serializer/mapTypenameToAPIType"
import {
  FloorTypename,
  ProductPositionTypename,
  ProjectTypename,
  RoomTypename
} from "shared/types/Project"

import { useAttachmentsQuery as useAttachmentsQueryGenerated } from "../graphql/project-attachments.queries.generated"

type AttachmentResourceTypename =
  | typeof ProjectTypename
  | typeof FloorTypename
  | typeof RoomTypename
  | typeof ProductPositionTypename

interface Args {
  id: string
  resourceType: AttachmentResourceTypename
  skip?: boolean
}

export function useAttachmentsQuery({ id, resourceType, skip }: Args) {
  return useAttachmentsQueryGenerated({
    variables: { id, type: mapTypenameToResourceType(resourceType) ?? "" },
    skip
  })
}
